// import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { useState, useEffect } from "react";
import fakeDispatch from "../../utils/fakeDispatch";
import useAdminDataStore, { selectRedirectPath } from "../../store/adminData/adminData";
import { disableLoginFlow, loadingUser } from "../../redux/actions/user";
import { fbAuth } from "../../services/firebaseService/connection";
import LoadingModal from "./LoadingModal";
import PhoneNumberInput from "./PhoneNumberInput";
import {
  isSignInWithEmailLink,
  RecaptchaVerifier,
  sendSignInLinkToEmail,
  signInWithEmailLink,
  signInWithPhoneNumber,
} from "firebase/auth";
import { fbGetUserByPhone } from "../../services/firebaseService/endPoints/user";
import logger from "../../utils/logger";
import { isEmailValid } from "../../utils/validation";
import ChantSpinner from "../../CommonComponents/ChantSpinner/ChantSpinner";
import { withRouter } from "../../utils/helper";

const MobileVerification = (props) => {
  const redirectPath = useAdminDataStore(selectRedirectPath);
  const path = { value: redirectPath };

  const [showEmailLogin, setShowEmailLogin] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(props.phoneNumber || "");
  const [countryCode, setCountryCode] = useState("");
  const [otp, setOtp] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [confirmResult, setConfirmResult] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showAlert, setShowAlert] = useState({ show: false, type: "success", message: "" });
  const [userEmail, setUserEmail] = useState("");

  // componentDidMount
  useEffect(() => {
    try {
      window.recaptchaVerifier = new RecaptchaVerifier(
        fbAuth,
        "sign-in-button",
        {
          size: "invisible",
          callback: () => {},
        }
      );

      window.recaptchaVerifier.render().then((id) => {
        logger.log(id);
      });

      if (isSignInWithEmailLink(fbAuth, window.location.href)) {
        const params = new URLSearchParams(window.location.search);

        let email = params.get("email");

        setIsLoading(true);

        if (email) {
          signInWithEmailLink(fbAuth, email, window.location.href)
            .then((result) => {
              if (result) {
                setIsLoading(false);
                fakeDispatch(loadingUser());
                if (path.value) {
                  props.router.navigate(path.value || "", {
                    replace: true,
                  });
                } else {
                  props.router.navigate("/", { replace: true });
                }
              }
            })
            .catch(() => {
              setIsLoading(false);
              setShowAlert({
                show: true,
                type: "error",
                message: "Failed to login by email link",
              });
            });
        }

        setIsLoading(false);
      }
      // }
    } catch (e) {
      setIsLoading(false);
      setShowAlert({
        show: true,
        type: "error",
        message:
          "Captcha Error in Safari? Either use Chrome (advised) or in Safari Settings/Privacy uncheck 'prevent cross-site ip tracking' and 'hide ip addresses from trackers'. Ensure either google or captcha.net are allowed to use 3rd party cookies.",
      });
    }

    // componentWillUnmount
    return () => {
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
        window.recaptchaVerifier = "";
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // auth = getAuth();

  const handleisChecked = (e) => {
    setIsChecked((prev) => !prev);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "otp") setOtp(value);
    else if (name === "userEmail") setUserEmail(value);
  };

  const handlePhoneChange = (phone, code) => {
    if (confirmResult) {
      setConfirmResult("");
    }
    setPhoneNumber(phone);
    setCountryCode(code);
  };
  // handleOtpChange = otp => {
  //   // if (confirmResult) {
  //   //   setConfirmResult("");
  //   // }
  //   setOtp(otp);
  // };

  const handleRequestOtp = () => {
    setIsLoading(true);
    setShowAlert({ show: false });

    let phoneNumberWithoutCode = "";

    if (phoneNumber.startsWith(countryCode)) {
      phoneNumberWithoutCode = phoneNumber.substring(countryCode.length);
    }

    if (phoneNumberWithoutCode.startsWith("0")) {
      phoneNumberWithoutCode = phoneNumberWithoutCode.substring(1);
    }

    const phone = `${countryCode}${phoneNumberWithoutCode}`;

    // if (!isValidPhoneNumber(phoneNumber)) {
    //   setShowAlert({
    //     show: true,
    //     type: "error",
    //     message: "Enter a valid phone number"
    //   });
    //   setIsLoading(false);
    //   return;
    // }
    if (!isChecked) {
      setShowAlert({
        show: true,
        type: "error",
        message: "Accept Terms & Conditions",
      });
      setIsLoading(false);
      return;
    }

    fbGetUserByPhone(phone).then((userData) => {
      if (userData && userData.id) {
        if (userData?.requiresEmailAuth || userData?.authEmail) {
          setShowEmailLogin(true);
          setUserEmail(userData.email);
          setIsLoading(false);

          // handleEmailLogin(userData?.email);
        } else {
          signInWithPhoneNumber(fbAuth, phone, window.recaptchaVerifier)
            .then((result) => {
              setConfirmResult(result);
              setIsLoading(false);
            })
            .catch((err) => {
              setIsLoading(false);
              setShowAlert({
                show: true,
                type: "error",
                message:
                  err.message === "TOO_SHORT"
                    ? "Enter a valid phone number"
                    : err.message,
              });
            });
        }
      } else {
        setIsLoading(false);
        setShowAlert({
          show: true,
          type: "error",
          message:
            "No account found. If logging in for the first time you must first Register in the Chant app.",
        });
      }
    });
  };

  const handleVerifyOtp = () => {
    setIsLoading(true);
    setShowAlert({ show: false });

    confirmResult
      .confirm(otp)
      .then((result) => {
        setIsLoading(false);
        fakeDispatch(loadingUser());
        if (path.value) {
          props.router.navigate(path.value || "", {
            replace: true,
          });
        } else {
          props.router.navigate("/", { replace: true });
        }
        // window.location.reload()
      })
      .catch((err) => {
        setIsLoading(false);
        setShowAlert({
          show: true,
          type: "error",
          message: "Invalid otp, try again",
        });
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleEmailLogin = () => {
    if (!isEmailValid(userEmail)) {
      setShowAlert({
        show: true,
        type: "error",
        message: "Email login failed - invalid email",
      });
      return;
    }

    setSendingEmail(true);
    setShowAlert({ show: false });

    const actionCodeSettings = {
      url: `https://register.chant.fan/login?email=${userEmail}`,
      handleCodeInApp: true,
      dynamicLinkDomain: "chant.page.link",
    };

    sendSignInLinkToEmail(fbAuth, userEmail, actionCodeSettings)
      .then(() => {
        setSendingEmail(false);
        setEmailSent(true);
        fakeDispatch(disableLoginFlow());
      })
      .catch((err) => {
        setSendingEmail(false);
        setShowAlert({
          show: true,
          type: "error",
          message: "Failed to login by email",
        });
      });
  };

  return (
    <>
      <div className="container mt-5" style={{ color: "#ffffff" }}>
        <LoadingModal loading={isLoading} />

        {showAlert.show && (
          <div className="alert alert-danger" role="alert">
            {showAlert.message}
          </div>
        )}

        <form
          onSubmit={handleSubmit}
          className="p-2 px-md-5 py-md-4 mx-auto"
          style={{
            maxWidth: "700px",
            height: "75vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div>
            <div className="form-group">
              <p
                style={{
                  fontSize: 22,
                  fontWeight: "bold",
                  marginBottom: 0,
                  paddingBottom: "8px",
                  textAlign: "center",
                }}
              >
                Admin login
              </p>
              {!showEmailLogin && (
                <p style={{ fontSize: 16, fontWeight: "bold" }}>
                  Log in to manage your group. You must first be registered in
                  the app.
                </p>
              )}
              {/* <PhoneInput
                className="form-control form-control-sm"
                placeholder="Enter your phone number"
                value={phoneNumber}
                // value={formatPhoneNumberIntl("+1")}
                onChange={handlePhoneChange}
                country="US"
              /> */}
              {!showEmailLogin ? (
                <div>
                  <div className="row" style={{ justifyContent: "center" }}>
                    <div className="col-md-8">
                      <PhoneNumberInput
                        onChange={(phone, code) => {
                          handlePhoneChange(phone, code);
                        }}
                        placeholder="Enter mobile number"
                      />
                    </div>
                  </div>
                  {!confirmResult ? (
                    <div style={{ textAlign: "center" }}>
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={handleisChecked}
                        style={{
                          marginRight: "7px",
                          marginTop: "10px",
                          marginLeft: "5px",
                        }}
                      />
                      I have read and accept the Chant{" "}
                      <span>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://www.chant.fan/terms"
                        >
                          Terms of use
                        </a>
                      </span>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
              ) : (
                <div style={{ textAlign: "center" }}>
                  <p
                    style={{
                      fontSize: "20px",
                      marginBottom: 0,
                      paddingTop: "10px",
                    }}
                  >
                    Authenticate via email
                  </p>
                  <p
                    style={{
                      color: "#EF4045",
                      marginBottom: 0,
                      paddingBottom: "12px",
                    }}
                  >
                    {userEmail}
                  </p>
                  {!emailSent && (
                    <p
                      style={{
                        fontSize: "16px",
                        marginBottom: 0,
                        paddingBottom: "16px",
                      }}
                    >
                      Email must be received on this device. Proceed?
                    </p>
                  )}
                  {sendingEmail ? (
                    <ChantSpinner />
                  ) : !emailSent ? (
                    <div className="flex-center" style={{ gap: "12px" }}>
                      <button
                        disabled={false}
                        className="btn"
                        style={{
                          border: "2px solid #ffffff",
                          backgroundColor: "transparent",
                          color: "#ffffff",
                        }}
                        onClick={handleEmailLogin}
                        id="sign-in-button"
                      >
                        Continue
                      </button>
                      <button
                        disabled={false}
                        className="btn"
                        style={{
                          border: "2px solid #ffffff",
                          backgroundColor: "transparent",
                          color: "#ffffff",
                        }}
                        onClick={() => setShowEmailLogin(false)}
                        id="sign-in-button"
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <p
                      style={{
                        fontSize: "16px",
                        marginBottom: 0,
                        paddingBottom: "16px",
                      }}
                    >
                      Email sent.
                    </p>
                  )}
                </div>
              )}
            </div>

            {!showEmailLogin && (
              <div className="form-group">
                {!confirmResult ? (
                  <>
                    <div className="d-flex justify-content-center mb-3">
                      <button
                        disabled={false}
                        className="btn"
                        style={{
                          border: "2px solid #ffffff",
                          backgroundColor: "transparent",
                          color: "#ffffff",
                        }}
                        onClick={handleRequestOtp}
                        id="sign-in-button"
                      >
                        Submit
                      </button>
                    </div>
                    <p style={{ fontSize: "12px", textAlign: "center" }}>
                      Authentication code sent via SMS. Charges may apply.
                    </p>
                  </>
                ) : (
                  <>
                    <div className="row" style={{ justifyContent: "center" }}>
                      <div className="form-group col-md-8">
                        <label>Enter Verification Code</label>
                        <div
                          style={{
                            background: "transparent",
                            border: "2px solid #ffffff",
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            marginRight: "0.5rem",
                            padding: "5px 10px",
                          }}
                          className="col"
                        >
                          <input
                            placeholder="Enter code sent via text message"
                            value={otp}
                            className="form-control form-control-sm"
                            name="otp"
                            style={{
                              background: "transparent",
                              border: 0,
                              outline: "none",
                              width: "100%",
                              color: "#ffffff",
                            }}
                            maxLength={6}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center">
                      <button
                        className="btn"
                        style={{
                          border: "2px solid #ffffff",
                          backgroundColor: "transparent",
                          color: "#ffffff",
                        }}
                        onClick={
                          props.handleVerifyOtp
                            ? props.handleVerifyOtp
                            : handleVerifyOtp
                        }
                      >
                        Login
                      </button>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </form>
      </div>
    </>
  );
};

export default withRouter(MobileVerification);
